import { render } from "./CallView.vue?vue&type=template&id=d8917efe"
import script from "./CallView.vue?vue&type=script&lang=js"
export * from "./CallView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__